import {
  Stack,
  Pagination,
  Select,
  MenuItem,
  InputLabel,
  useMediaQuery,
} from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface PaginationProps {
  totalCount: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  pageSizeOptions?: number[];
}

export const CustomPagination: FC<PaginationProps> = ({
  totalCount,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 30, 40, 50],
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Stack
      spacing={2}
      sx={{
        margin: "30px auto 20px auto",
        maxWidth: "500px",
        alignItems: "center",
        "@media (max-width: 515px)": { width: "300px" },
        "@media (max-width: 420px)": { width: "260px" },
        "@media (max-width: 320px)": { width: "240px" },
        "@media (max-width: 280px)": { width: "200px" },
      }}
    >
      <Pagination
        count={Math.ceil(totalCount / pageSize)}
        page={page}
        onChange={(_, value) => onPageChange(value)}
        color="primary"
        size={isMobile ? "small" : "medium"}
        variant="outlined"
        shape="rounded"
        sx={{ margin: "0 auto" }}
      />
      <>
        <Select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: "12px",
                padding: "0 10px",
                "& .MuiMenuItem-root:hover": { backgroundColor: "#e3f2fd" },
              },
            },
          }}
          sx={{
            borderRadius: "12px",
            border: "1px solid #C0D4E3",
            width: { xs: "70px", sm: "100px" },
            margin: "0 auto",
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            ".MuiSelect-select": {
              padding: { xs: "6px 24px 6px 8px", sm: "10px 32px 10px 12px" },
              color: "#3E444A",
              fontFamily: "Raleway",
              fontSize: { xs: "12px", sm: "14px" },
              lineHeight: "24px",
            },
          }}
        >
          {pageSizeOptions.map((value) => (
            <MenuItem
              key={value}
              value={value}
              sx={{ borderRadius: "10px", fontSize: { xs: "12px", sm: "14px" } }}
            >
              {value}
            </MenuItem>
          ))}
        </Select>
        <InputLabel sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
          {t("activeMarathonListOfParticipants.quantity")}
        </InputLabel>
      </>
    </Stack>
  );
};
